/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import {
  bus
} from '../../main';
import toast from '../../services/toast';

export default {
  name: 'course-search',
  components: {},
  data() {
    return {
      courses: {},
      courseListResults: [],
      categoryList: {},
      categoryFilterName: 'Select Category',
      searchCourseData: {},
      id: '',
      preloader: true,
      loader: false,
      deleteCourseId: '',
      isRoleIn:''
    }
  },
  computed: {
    ...mapGetters([
      'getsearchCourseByParamState',
      'getCategoryListState',
      'getCourseByCategoryState',
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryListState;
      return this.categoryList
    },
    getSearchDataByName() {
      this.loader = true;
      this.$store.dispatch('getsearchCourseByParam', {
        id: this.$route.params.searchkeyword
      }).then((response) => {
        if (response.data.code == '2000') {
          this.loader = false;
          return this.courses = this.$store.getters.getsearchCourseByParamState.data
        }
      })
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results
      }
    },
    getUserDetails() {
      this.$store.dispatch('getUserRoleDetails').then((res) => {
        this.isRoleIn = res.data.data.profile.role
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getUserDetails
    this.getSearchDataByName
    this.getCategory
    this.SetIntialStatus
    this.preloader = false
    if(this.$route.params.searchkeyword){
     bus.$emit('ShowSearchKeyWord', this.$route.params.searchkeyword);
    }
  },
  methods: {
    viewCourseDetailsFun(id) {
      this.$router.push('/course/' + id + "/tab/")
      return this.courses = this.$store.getters.getlastestCoursesState.data;
    },
    getCoursebyCategory(id, name) {
      this.loader = true;
      if (id != "") {
        this.$router.push('/usercourses/category/' + id + "/")
      } else {
        this.$router.push('/courses/')
        this.loader = false;
      }
      this.categoryFilterName = name;
    },
    deleteCourseFun(id) {
      this.deleteCourseId = id
      $('#removeCourseModal').modal()
    },
    removeCourseModalConfirmation() {
      let data = {
        id: this.deleteCourseId
      }
      this.$store.dispatch('removeCourseFun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.getCourseDetailsAgain()
            toast.success(res.data.msg);
          }
        })
        .catch((err) => {})
    }

  },
  beforeMount() {
    this.getSearchDataByName
  },
  watch: {
    getSearchDataByName() {
      return this.$store.getters.getsearchCourseByParamState
    },
    getCategory() {
      return this.$store.getters.getCategoryListState
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
    bus.$emit('ShowSearchKeyWord', '');
    next();
  }
}